/**
 * recommendModules/helpers/processPolygonGroups.js
 * Polygon gruplarını işleyen yardımcı fonksiyon
 */

const { weightedAverage } = require('../tools/weightedAverage');

/**
 * Polygon gruplandırma ve sıralama için optimize edilmiş fonksiyon
 * @param {Array} vehicles - Araçlar listesi
 * @returns {Array} İşlenmiş araçlar listesi
 */
function processPolygonGroups(vehicles) {
  // İlk önce polygon gruplarını oluştur (Map kullanarak)
  const polygonGroups = new Map();
  
  // Sadece polygon adı olanları grupla
  vehicles.forEach(vehicle => {
    if (vehicle.polygonId) {
      if (!polygonGroups.has(vehicle.polygonId)) {
        polygonGroups.set(vehicle.polygonId, []);
      }
      polygonGroups.get(vehicle.polygonId).push(vehicle);
    }
  });
  
  polygonGroups.forEach(group => {
    // En düşük maliyeti ve bu maliyete sahip aracı bul
    let minCost = Infinity;
    let minCostVehicle = null;
  
    group.forEach(vehicle => {
      if (vehicle.allCost < minCost) {
        minCost = vehicle.allCost;
        minCostVehicle = vehicle;
      }
    });
  
    // En düşük maliyetli aracın priority bilgisini kullan
    const sortingPriority = minCostVehicle?.priority ?? null;
  
    // Tüm araçlara aynı minCost ve sortingPriority'yi ata
    group.forEach(vehicle => {
      vehicle.sortingCost = minCost;
      vehicle.sortingPriority = sortingPriority;
    });
  });
  
  // costPriorityAverage değerlerini bir defada hesapla
  vehicles.forEach(vehicle => {
    const sortingCost = vehicle.polygonId ? (vehicle.sortingCost || vehicle.allCost) : vehicle.allCost;
    
    // priority değerini bir kez hesapla ve cache'le
    const priorityValue = vehicle?.sortingPriority ?? parseFloat((vehicle?.priority ?? 0).toFixed(3));
    vehicle.costPriorityAverage = weightedAverage(
      priorityValue,
      0.3,
      sortingCost,
      0.7
    );
  });
  
  return vehicles;
}

module.exports = processPolygonGroups;